import { Box, styled } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { useTheme } from '../../contexts/useTheme';

const StyledToggleButton = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: 44,
  height: 22,
  borderRadius: 11,
  backgroundColor: theme.palette.mode === 'light' ? '#e2e8f0' : '#475569',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  display: 'flex',
  alignItems: 'center',
  padding: '2px',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'light' ? '#cbd5e1' : '#64748b'
  }
}));

const ToggleSlider = styled(Box, {
  shouldForwardProp: prop => prop !== 'isLight'
})<{ isLight: boolean }>(({ theme, isLight }) => ({
  width: 18,
  height: 18,
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  transform: isLight ? 'translateX(0)' : 'translateX(22px)',
  transition: 'transform 0.3s ease',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
}));

const ThemeToggle = () => {
  const { mode, toggleTheme } = useTheme();
  const isLight = mode === 'light';

  return (
    <StyledToggleButton onClick={toggleTheme}>
      <ToggleSlider isLight={isLight}>
        {isLight ? (
          <LightMode sx={{ fontSize: 12, color: 'white' }} />
        ) : (
          <DarkMode sx={{ fontSize: 12, color: 'white' }} />
        )}
      </ToggleSlider>
    </StyledToggleButton>
  );
};

export default ThemeToggle;
